(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.isATNAHeader = !!this.querySelector('.atna-header-search');
      if (this.isATNAHeader) this.header.classList.add('atna-compact-scroll');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.onResizeHandler = this.setHeaderHeight.bind(this);
      window.addEventListener('resize', this.onResizeHandler, { passive: true });
      if (this.isATNAHeader && 'ResizeObserver' in window) {
        this.headerResizeObserver = new ResizeObserver(this.onResizeHandler);
        this.headerResizeObserver.observe(this.header);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      const compact = this.isATNAHeader && this.header.classList.contains('scrolled-past-header');
      if (compact) this.header.classList.remove('scrolled-past-header');
      const height = this.header.getBoundingClientRect().height;
      if (this.isATNAHeader) {
        this.header.style.setProperty('--atna-expanded-header-height', height + 'px');
        this.headerBounds = { top: 0, bottom: height };
      }
      if (compact) this.header.classList.add('scrolled-past-header');
      document.documentElement.style.setProperty('--header-height', height + 'px');
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      this.headerResizeObserver?.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.isATNAHeader) { this.onATNAScroll(Math.max(0, scrollTop)); return; }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    onATNAScroll(scrollTop) {
      const focusedInput = this.contains(document.activeElement) &&
        document.activeElement.matches('input, textarea, select');
      if ((this.predictiveSearch && this.predictiveSearch.isOpen) ||
          focusedInput || this.querySelector('details[open]')) {
        this.currentScrollTop = scrollTop;
        this.atnaScrollAnchor = scrollTop;
        return;
      }
      const delta = scrollTop - this.currentScrollTop;
      const direction = delta > 0 ? 'down' : delta < 0 ? 'up' : this.atnaScrollDirection;
      if (direction !== this.atnaScrollDirection) {
        this.atnaScrollAnchor = this.currentScrollTop;
        this.atnaScrollDirection = direction;
      }
      const distance = Math.abs(scrollTop - (this.atnaScrollAnchor || 0));
      if (scrollTop <= 0) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
        this.atnaScrollAnchor = 0;
        this.setHeaderHeight();
      } else if (scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (direction === 'down' && distance >= 12 && !this.preventHide) {
          requestAnimationFrame(this.hide.bind(this));
        } else if (direction === 'up' && distance >= 28) {
          if (!this.preventReveal) { requestAnimationFrame(this.reveal.bind(this)); }
          else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        }
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
